/**
 * @GENERATED from Figma node 3608:51035
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SuperhumanDark = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <circle cx={12} cy={12} r={10} fill="#0B0B0B" />
      <path
        fill={`url(#${_id})`}
        fillRule="evenodd"
        d="M11.986 6.076a.365.365 0 0 1 .445 0l4.853 3.771a.34.34 0 0 1 .133.267.34.34 0 0 1-.133.267l-2.057 1.599 2.06 1.641c.083.066.13.164.13.267-.001.103-.05.2-.133.265l-4.853 3.771a.365.365 0 0 1-.445 0l-4.854-3.771A.34.34 0 0 1 7 13.886c0-.104.049-.202.132-.267L9.215 12l-2.083-1.619A.34.34 0 0 1 7 10.114c0-.104.049-.202.132-.267zM9.782 12.44l-1.86 1.446 4.286 3.331 3.846-2.988h-3.846a.36.36 0 0 1-.222-.076zm6.291 1.103h-2.857l1.446-1.124zm-3.865-.097-4.287-3.332 4.287-3.331 4.287 3.331z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={17.653}
          x2={7.237}
          y1={11.714}
          y2={11.714}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#56C8E2" />
          <stop offset={0.5} stopColor="#C1C1E1" />
          <stop offset={1} stopColor="#F9E6F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(SuperhumanDark);
export { ForwardRef as SuperhumanDark };
